<div class="menu-card-el-container">
  <img [src]="background" [style]="style" alt="card" style="filter: brightness(0.95);">
</div>
